import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

// configs
import configs from '@/config'

// utils
import utils from '@/util'

export default (component) => Vue.component('FooterContainer', {
  data() {
    return {
      isWhiteLabelUser: false,
    }
  },
  computed: {
    ...mapGetters('presentationSettings', [
      'isEnableAudienceAdmissionForm',
    ]),
    ...mapGetters({
      slide: 'activeActivity',
    }),
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    footerBannerURL() {
      return `${configs.presenterUrl}/pages/register?source=presentation_${this.presentation.id}&medium=audience_app&campaign=footer_banner&content=${utils.getSlideType(this.slide)}`
    },
  },
  methods: {
    handleAudienceCtaClick() {
      utils.trackGAButtonCTA(this.presentation.id, this.slide)
    },
  },
  render(createElement) {
    return createElement(component, {
      props: {
        footerBannerURL: this.footerBannerURL,
        handleAudienceCtaClick: this.handleAudienceCtaClick,
        enableAudienceAdmissionForm: this.isEnableAudienceAdmissionForm,
      },
    })
  },
})
